import React, { useState } from 'react';

export const ProfilePassword = () => {
    return(
        <h2>Password Page</h2>
    )
}